import { render, staticRenderFns } from "./Ciencia.vue?vue&type=template&id=2cb16697&lang=pug&"
import script from "./Ciencia.vue?vue&type=script&lang=js&"
export * from "./Ciencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports